import { render, staticRenderFns } from "./header-page.vue?vue&type=template&id=4a12dd5f&scoped=true&"
import script from "./header-page.vue?vue&type=script&lang=js&"
export * from "./header-page.vue?vue&type=script&lang=js&"
import style0 from "./header-page.vue?vue&type=style&index=0&id=4a12dd5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a12dd5f",
  null
  
)

export default component.exports